"use strict";

Shopify.theme.jsGoogleTestimonials = {
  isRendered:false,
  googlePlaceId: "ChIJEY4HHoTN54gRnse4KJukDtk",
  filledStar: document.getElementsByClassName("filledStar")[0],
  halfStar: document.getElementsByClassName("halfStar")[0],
  emptyStar: document.getElementsByClassName("emptyStar")[0],
  init: function init($section) {
    var result = null;
    var latestInfo = localStorage.getItem("latestReviewCheck");
    latestInfo = latestInfo == null ? new Date() : new Date(latestInfo);
    let sevenDaysAgo  = new Date()
    sevenDaysAgo = sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 30)
    if (latestInfo.getTime() >= sevenDaysAgo) {
        const info = localStorage.getItem("googleReviewsInfo");
        if (info) { result = JSON.parse(info); }
    }
    if (!result) {
      console.log('fetching Reviews')
        new google.maps.places.PlacesService(new google.maps.Map(document.createElement("div"))).getDetails(
            {
                placeId: this.googlePlaceId,
                //fields: ['name', 'rating', 'user_ratings_total', 'reviews']
            },
            async (place, status) => {
                if (status == google.maps.places.PlacesServiceStatus.OK) {
                    console.log(place);
                    localStorage.setItem("googleReviewsInfo", JSON.stringify(place));
                    localStorage.setItem("latestReviewCheck", JSON.stringify(new Date().toDateString()));
                    this.renderReviews(place);
                }
            });
    } else {
        console.log("Review Exist")
        this.renderReviews(result);
    }
  },
  renderReviews: function renderReviews(place){
    if (this.isRendered || !place) return;
    document.getElementById("googlePlaceScore").innerText = `${place.rating}`;
    this.renderScore($(".googlePlaceStars"), place.rating);
    if(document.getElementById("googlePlaceNumReviews")){
      document.getElementById("googlePlaceNumReviews").innerText = `(${place.user_ratings_total} reviews)`;
    }
    document.getElementById("googlePlace").removeAttribute("hidden");

    const reviewHolder = document.getElementById("googlePlaceReviews");
    if(reviewHolder){
    const reviewTemplateOriginalElement = document.getElementsByClassName("googleReviewItem")[0];
    const reviewTemplateElement = reviewTemplateOriginalElement.cloneNode(true);
    reviewTemplateOriginalElement.parentNode.removeChild(reviewTemplateOriginalElement);

    for (var j = 0; j < place.reviews.length; j++) {
        const reviewElement = reviewTemplateElement.cloneNode(true);
        const author = reviewElement.getElementsByClassName("googleReviewAuthor")[0];
        author.innerText = place.reviews[j].author_name;
        author.setAttribute("href", place.reviews[j].author_url);
        reviewElement.getElementsByClassName("googleReviewAuthorImage")[0].setAttribute("src", place.reviews[j].profile_photo_url);
        this.renderScore($(reviewElement).find(".googleReviewScore"), place.reviews[j].rating);
        reviewElement.getElementsByClassName("googleReviewContent")[0].innerText = place.reviews[j].text;
        reviewHolder.appendChild(reviewElement);
    }
    const starsTemplateElement = document.getElementById("starsTemplate");
    starsTemplateElement.parentNode.removeChild(starsTemplateElement);
      this.isRendered = true;
    }
  },
  renderScore: function renderScore(element, score) {
    if(typeof element =='object'){
      element.each((index,item)=>{
        var remainingScore = score;
        for (var i = 0; i < 5; i++) {
            if (remainingScore >= 1) {
                element[index].appendChild(this.filledStar.cloneNode(true));
                remainingScore--;
            } else if (remainingScore > 0) {
                element[index].appendChild(this.halfStar.cloneNode(true));
                remainingScore = 0;
            } else {
                element[index].appendChild(this.emptyStar.cloneNode(true));
            }
        }             
     })
    }else{
      var remainingScore = score;
          if (remainingScore >= 1) {
              element.appendChild(this.filledStar.cloneNode(true));
              remainingScore--;
          } else if (remainingScore > 0) {
              element.appendChild(this.halfStar.cloneNode(true));
              remainingScore = 0;
          } else {
              element.appendChild(this.emptyStar.cloneNode(true));
          }
      }
    
  },
  unload: function unload($section) {
  }
};